import { render, staticRenderFns } from "./OpenBankingLandingPage.vue?vue&type=template&id=30663faa&scoped=true"
import script from "./OpenBankingLandingPage.vue?vue&type=script&lang=js"
export * from "./OpenBankingLandingPage.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingLandingPage.vue?vue&type=style&index=0&id=30663faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30663faa",
  null
  
)

export default component.exports